// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".border-green[data-v-3588e075] {\n  border-color: #2DB782;\n}\n[data-v-3588e075] .custom-nav-container {\n  border-bottom: 1px solid #e1e1e1;\n}\n[data-v-3588e075] .custom-nav-container .nav-item .nav-link {\n  font-size: 17.6px;\n  font-weight: 700;\n}\n[data-v-3588e075] .custom-nav-container .nav-item .nav-link.active {\n  border-bottom: 3px solid #2db782;\n  color: #2db782;\n}", ""]);
// Exports
module.exports = exports;
